exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nfooter .right[data-v-31bdab8a]{text-align:right;clear:both;float:right\n}\nfooter small[data-v-31bdab8a]{clear:both;color:#ccc\n}\nfooter footer>div>small[data-v-31bdab8a]::nth-child(2){color:#aaa !important\n}\n", ""]);

// exports
